export const PERMISSIONS = {
    PRODUTO_LIST: "admin.produto.list",
    TIPO_CARGA_LIST: "admin.tipo_carga.list",
    CATEGORIA_CARGA_ANTT_LIST: "admin.categoria_carga_antt.list",
};

export const hasPermission = (userPermissions, requiredPermission) => {
    if (!Array.isArray(userPermissions)) {
        return false;
    }
    if (Array.isArray(requiredPermission)) {
        return requiredPermission.some((permission) => userPermissions.includes(permission));
    }
    return userPermissions.includes(requiredPermission);
};
